import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../Themes/Components/AbstractElements';
import PageLoader from '../../../Themes/Layout/PageLoader';
import Chart from '../Components/Chart';
import { DASHBOARD_IMPORTACAO_GRAFICOS } from '../../../Themes/Config/appConfig';

const DashboardImportacao = () => {
  const graficos = JSON.parse(localStorage.getItem(DASHBOARD_IMPORTACAO_GRAFICOS));

  return (
    <Fragment>
      <PageLoader loaded={graficos.loading} />
      <Breadcrumbs mainTitle='Dashboard - Importação' title='Importação' parent='Dashboard' />
      <Container fluid={true} className='ecommerce-page'>
        <Row>
          {graficos &&
            graficos.map((graficoData, index) => <Chart key={index} data={graficoData} plugin={'importacao'} />)}
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardImportacao;
